module.exports = __webpack_public_path__ + "img/route_country.4acbd13.webp";